import type { FaireProductEntity } from "../../entity_types/product";

export const p_n7udmsnmuy: FaireProductEntity = {
  token: "p_n7udmsnmuy",
  type: "product",
  name: "Mini Mancala",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/b3bdb6bc2e3e1e911592437e8c6560409cea2ed75d831ba6f8fc77d31607d1a7.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.98,
  description: "Play mancala right at your desk with this miniature travel-size version! The ideal on-the-go companion when you want to have some fun with friends or just unplug. It includes a 7-inch foldable gameboard made from quality wood, 48 colored beads (“stones”), and a band to hold the gameboard tightly together when not in use. A 32-page fully illustrated mini book with gameplay instructions, rules for scoring, beginner strategies, and variations of the game is also included. Its mini size is perfect for a desktop or taking on the go, making it a unique gift for fans of mancala and of desktop games, suitable for players of all ages.",
  tags: [],
  msrpDollars: 11.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:51.825Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
